// Messages the server sends in English (server/app.py, server/assets/room_protocol.py).
// Listing them here puts them in the catalogs; t() then translates them wherever they are shown.
import { registerTemplates, tk } from './index';

export const SERVER_MESSAGES = [
    tk('Add a rating or a comment.'),
    tk('Add at least 2 locations before you start the game.'),
    tk('At least 1 intruder is required.'),
    tk('At least 2 locations are required to create a task list'),
    tk('Cannot add tasks while game is running'),
    tk('Cannot change locations while game is running'),
    tk('Cannot change settings while game is running'),
    tk('Cannot change tasks while game is running'),
    tk('Cannot remove tasks while game is running'),
    tk('Cannot toggle task creation during game'),
    tk('Choose one of the available ratings.'),
    tk('Code and task index required'),
    tk('Code and task required'),
    tk('Device ID required to save task list'),
    tk('Failed to add task'),
    tk('Failed to create task list'),
    tk('Failed to duplicate task list'),
    tk('Failed to remove task'),
    tk('Failed to save task list'),
    tk('Failed to update task list. You may not be the owner.'),
    tk('Feedback did not save. Try again.'),
    tk('Game not found'),
    tk('Give feedback after this round ends.'),
    tk('Invalid task index'),
    tk('Keep the comment within 1,000 characters.'),
    tk('No tasks to save'),
    tk('Not in a game room'),
    tk('Only players in this game can send feedback.'),
    tk('Only the host can add tasks. Ask them to enable collaborative mode.'),
    tk('Only the host can change this setting'),
    tk('Only the host can edit locations'),
    tk('Only the room creator can change settings'),
    tk('Only the room creator can change task settings'),
    tk('Only the room creator can open the room'),
    tk('Open the room before you start the game.'),
    tk('Player ID and code required'),
    tk('Player ID required'),
    tk('Rejoin the room before you send feedback.'),
    tk('Room code is required'),
    tk('Room has been closed'),
    tk('Room is not open yet'),
    tk('Task description required'),
    tk('Task list code required'),
    tk('Task list not in your saved lists.'),
    tk('Tasks complete. Find the intruders.'),
    tk('The action failed.'),
    tk('The action failed. Try again, or reconnect to the room.'),
    tk('The game already started.'),
    tk('The round has not ended.'),
    tk('Username is required'),
    tk('You do not own this task list. Use "Save As New" to create your own copy.'),
    tk('You join at the start of the next round.'),
    tk('Your previous session is no longer available. Ask the host for a new invite.'),
];

// Messages with values filled in on the server.
export const SERVER_TEMPLATES = [
    tk('Need at least {players} players for {intruders} intruder(s).'),
    tk('Add {missing} more tasks to start. {players} players need {needed}; the room has {have}.'),
    tk('Add {missing} more task to start. {players} players need {needed}; the room has {have}.'),
    tk('Task list not found: {code}'),
];

registerTemplates(SERVER_TEMPLATES);
